$(document).ready(function () {

    if ($('.ele-prg').length > 0) {

        loadEventsAndLearningContentBySpecialities();
        loadEventsAndLearningContentByHospitals();
        loadEventsBySearchText();
        loadEventsAndLearningContentByPresenter();
        loadPresentersBySearchText();
        loadLearningContentSearchText();
        $('#SelectedElevateSpeciality').change(function () {

            loadEventsAndLearningContentBySpecialities();

            var selectedText = $('#SelectedElevateSpeciality option:selected').text();

            if (selectedText && selectedText != "") {

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'elevatescreensearch',
                    'searchtext': selectedText
                });

                console.log("Data Layer Push: ", selectedText);
            }

        });

        $('#SelectedHospital').change(function () {

            loadEventsAndLearningContentByHospitals();

        });

        $('input[type=radio][name=flexRadioDefault]').change(function () {

            loadEventsAndLearningContentBySpecialities();
            loadEventsAndLearningContentByHospitals();
            loadEventsAndLearningContentByPresenter();
            loadPresentersBySearchText();
            loadLearningContentSearchText();
        });

        // Trigger function on clicking the search icon
        $('#div-events-search').click(function () {
            loadEventsBySearchText();
        });

        $('#div-presenters-search').click(function () {
            loadPresentersBySearchText();
        });

        $('#div-learning-content-search').click(function () {
            loadLearningContentSearchText();
        });


        // Trigger function on pressing Enter key while the textbox is focused
        $('.ele-events input[name="SearchText"]').keypress(function (e) {
            if (e.which == 13) { // Enter key corresponds to keycode 13
                e.preventDefault(); // Prevent the default action (form submission)
                loadEventsBySearchText();
            }
        });

        $('.ele-presenters input[name="SearchText"]').keypress(function (e) {
            if (e.which == 13) { // Enter key corresponds to keycode 13
                e.preventDefault(); // Prevent the default action (form submission)
                loadPresentersBySearchText();
            }
        });

        $('.ele-learning-content input[name="SearchText"]').keypress(function (e) {
            if (e.which == 13) { // Enter key corresponds to keycode 13
                e.preventDefault(); // Prevent the default action (form submission)
                loadLearningContentSearchText();
            }
        });

        $('.ele-events input[name="flexRadioDefault"]').change(function () {
            /* var filterType = $(this).val();*/
            loadEventsBySearchText();
        });

    }

});

function loadEventsAndLearningContentBySpecialities() {

    if ($(".ele-specs").length > 0) {

        $("#elevate-specialities-loader").css("display", "block");
        $('#elevate-event-and-content-area-id').html("");

        var titleText = "Content";

        var selectedSpeciality = $('#SelectedElevateSpeciality').val();
        var filterType = $('input[type=radio][name=flexRadioDefault]:checked').val();

        if (filterType == "events") {
            titleText = "Events";
        }
        else if (filterType == "presentations") {
            titleText = "Learning Content";
        }

        if (!selectedSpeciality || selectedSpeciality == null) {
            selectedSpeciality = 0;
            $("#elevate-specialities-search-header").html("All " + titleText);
        }
        else {
            $("#elevate-specialities-search-header").html("All " + titleText + " related to '" + $('#SelectedElevateSpeciality :selected').text() + "'");
        }

        $.ajax({
            url: '/ElevateSpecialities/GetContentBySpecialityId',
            type: 'GET',
            data: { seletedSpeciality: selectedSpeciality, filterType: filterType },
            success: function (data) {
                $('#elevate-event-and-content-area-id').html(data);
                $("#elevate-specialities-loader").css("display", "none");
            },
            error: function () {
                //alert("An error occurred while loading content.");
            }
        });
    }
}

function loadEventsAndLearningContentByHospitals() {

    if ($(".ele-hospitals").length > 0) {

        $("#elevate-specialities-loader").css("display", "block");
        $('#elevate-event-and-content-area-id').html("");

        var titleText = "Content";

        var selectedHospital = $('#SelectedHospital').val();
        var filterType = $('input[type=radio][name=flexRadioDefault]:checked').val();

        if (filterType == "events") {
            titleText = "Events";
        }
        else if (filterType == "presentations") {
            titleText = "Learning Content";
        }

        if (!selectedHospital || selectedHospital == null) {
            selectedHospital = 0;
            $("#elevate-specialities-search-header").html("All " + titleText);
        }
        else {
            $("#elevate-specialities-search-header").html("All " + titleText + " related to '" + $('#SelectedHospital :selected').text() + "'");
        }

        var selectedText = $('#SelectedHospital option:selected').text();

        if (selectedText && selectedText != "") {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'elevatescreensearch',  
                'searchtext': selectedText
            });

            console.log("Data Layer Push: ", selectedText);
        }

        $.ajax({
            url: '/ElevateHospitals/GetContentByHospitalId',
            type: 'GET',
            data: { seletedSpeciality: 0, seletedHospital: selectedHospital, filterType: filterType },
            success: function (data) {
                $('#elevate-event-and-content-area-id').html(data);
                $("#elevate-specialities-loader").css("display", "none");
            },
            error: function () {
                //alert("An error occurred while loading content.");
            }
        });
    }
}

function loadEventsBySearchText() {

    if ($(".ele-events").length > 0) {

        $("#elevate-specialities-loader").css("display", "block");
        $('#elevate-event-and-content-area-id').html("");

        var titleText = "Events";

        var searchText = $('#SearchText').val();
        var filterType = $('input[type=radio][name=flexRadioDefault]:checked').val();

        if (filterType == "groupbyhospital") {
            titleText = "events grouped by hospital";
        }
        else if (filterType == "groupbyspeciality") {
            titleText = "events grouped by speciality";
        }

        if (!searchText || searchText == null) {
            $("#elevate-specialities-search-header").html("All " + titleText);
        }
        else {
            $("#elevate-specialities-search-header").html("All " + titleText + " related to '" + searchText + "'");
        }

        if (searchText && searchText.trim() !== '') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'elevatescreensearch',
                'searchtext': searchText
            });

            console.log('Data Layer Push: SearchText = ' + searchText); // For testing purposes
        }

        $.ajax({
            url: '/ElevateEvents/GetElevateEventsBySearchText',
            type: 'GET',
            data: { searchText: searchText, filterType: filterType },
            success: function (data) {
                $('#elevate-event-and-content-area-id').html(data);
                $("#elevate-specialities-loader").css("display", "none");
            },
            error: function () {
                //alert("An error occurred while loading content.");
            }
        });
    }
}

function loadEventsAndLearningContentByPresenter() {

    if ($(".ele-presenter").length > 0) {

        $("#elevate-specialities-loader").css("display", "block");
        $('#elevate-event-and-content-area-id').html("");

        var titleText = "Content";
        _isvisitor = false;

        var presenter = getParameterByName('id');
        var isvisitor = getParameterByName('v');
        var filterType = $('input[type=radio][name=flexRadioDefault]:checked').val();

        if (filterType == "events") {
            titleText = "Events";
        }
        else if (filterType == "presentations") {
            titleText = "Learning Content";
        }

        $("#elevate-specialities-search-header").html("All " + titleText + " by " + $("#h1-doctor-name").html());

        if (!presenter || presenter == null) {
            presenter = 0;
        }

        if (isvisitor == null || isvisitor == "0")
            _isvisitor = false;

        if (isvisitor == "1")
            _isvisitor = true;

        $.ajax({
            url: '/ElevatePresenter/GetContentByPresenterId',
            type: 'GET',
            data: { presenter: presenter, filterType: filterType, isvisitor: _isvisitor },
            success: function (data) {
                $('#elevate-event-and-content-area-id').html(data);
                $("#elevate-specialities-loader").css("display", "none");
            },
            error: function () {
                //alert("An error occurred while loading content.");
            }
        });
    }
}

function loadPresentersBySearchText() {

    if ($(".ele-presenters").length > 0) {

        $("#elevate-specialities-loader").css("display", "block");
        $('#elevate-event-and-content-area-id').html("");
        var presenterIds = "";
        var visitorPresenterIds = "";
        var isevent = false;

        if ($("#hdnEventPresenterIds") && $("#hdnEventPresenterIds").val() && $("#hdnEventPresenterIds").val() != '') {
            presenterIds = $("#hdnEventPresenterIds").val();
        }

        if ($("#hdnEventVisitorPresenterIds") && $("#hdnEventVisitorPresenterIds").val() && $("#hdnEventVisitorPresenterIds").val() != '') {
            visitorPresenterIds = $("#hdnEventVisitorPresenterIds").val();
        }

        if ($("#hdnIsEvent") && $("#hdnIsEvent").val() && $("#hdnIsEvent").val() != '') {
            isevent = $("#hdnIsEvent").val();
        }

        var titleText = "Presenters";

        var searchText = $('#SearchText').val();
        var filterType = $('input[type=radio][name=flexRadioDefault]:checked').val();

        if (searchText && searchText.trim() !== '') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'elevatescreensearch',
                'searchtext': searchText
            });

            console.log('Data Layer Push: SearchText = ' + searchText);
        }

        if (filterType == "groupbyhospital") {
            titleText = "events grouped by hospital";
        }
        else if (filterType == "groupbyspeciality") {
            titleText = "events grouped by speciality";
        }

        if (!searchText || searchText == null) {
            $("#elevate-specialities-search-header").html("All " + titleText);
        }
        else {
            $("#elevate-specialities-search-header").html("All " + titleText + " related to '" + searchText + "'");
        }

        $.ajax({
            url: '/ElevatePresenters/GetContentByPresenters',
            type: 'GET',
            data: { searchText: searchText, filterType: filterType, presenterIds: presenterIds, visitorPresenterIds: visitorPresenterIds, isevent: isevent },
            success: function (data) {
                $('#elevate-event-and-content-area-id').html(data);
                $("#elevate-specialities-loader").css("display", "none");
            },
            error: function (e) {
                //alert("An error occurred while loading content.");
            }
        });
    }
}

function loadLearningContentSearchText() {

    if ($(".ele-learning-content").length > 0) {

        $("#elevate-specialities-loader").css("display", "block");
        $('#elevate-learning-content-area-id').html("");

        var titleText = "Learning Content";

        var searchText = $('#SearchText').val();
        var filterType = $('input[type=radio][name=flexRadioDefault]:checked').val();

        if (filterType == "groupbycpd") {
            titleText = "learning content grouped by cpd approved";
        }
        else if (filterType == "groupbyspeciality") {
            titleText = "learning content grouped by speciality";
        }

        if (searchText && searchText.trim() !== '') {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'elevatescreensearch',
                'searchtext': searchText
            });

            console.log('Data Layer Push: SearchText = ' + searchText);
        }

        if (!searchText || searchText == null) {
            $("#elevate-specialities-search-header").html("All " + titleText);
        }
        else {
            $("#elevate-specialities-search-header").html("All " + titleText + " related to '" + searchText + "'");
        }

        $.ajax({
            url: '/ElevateLearning/GetLearningContent',
            type: 'GET',
            data: { searchText: searchText, filterType: filterType },
            success: function (data) {
                $('#elevate-learning-content-area-id').html(data);
                $("#elevate-specialities-loader").css("display", "none");
            },
            error: function () {
                //alert("An error occurred while loading content.");
            }
        });
    }
}

function getParameterByName(name) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var url = window.location.href;
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}